import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import URL_UTILITY from '../../../utility/url.utility';
import previewDoc from '../../onlineApproval/internalWorkFlow/history/uploadDocument/previewDoc';

export default {
  name: 'tds',
  components: { previewDoc },
  watch: {
    currentPage: function() {
      this.getTdsFormData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getTdsFormData();
    }
  },
  data() {
    return {
      loader: false,
      assessmentYear: {
        text: null,
        value: null
      },
      panNumber: null,
      showOpenModal: false,
      pageOptions: commonHelper.getPageOption(),
      downloadDocUrl: URL_UTILITY.getOpenKmDocDeleteUrl,
      currentPage: 1,
      perPage: commonHelper.perPageRecord,
      totalRows: null,
      showValueSetModal: false,
      vsetCode: null,
      tdsCertificateData: [],
      tdsCertificateFields: [
        {
          key: 'le_name',
          class: 'text-center',
          label:'Legal Entity'
        },
        {
          key: 'vendor_pan_no',
          label: 'PAN Number',
          class: 'text-center'
        },
        {
          key: 'tan_no',
          class: 'text-center'
        },
        {
          key: 'assessment_year',
          class: 'text-center'
        },
        {
          key: 'certificate_no',
          class: 'text-center'
        },
        {
          key: 'from_date',
          class: 'text-center'
        },
        {
          key: 'to_date',
          class: 'text-center'
        },
        {
          key: 'base_amount',
          class: 'text-right'
        },
        {
          key: 'tds_amount',
          label: 'TDS Amount',
          class: 'text-right'
        },
        {
          key: 'openkm_uuid',
          label: 'Download',
          class: 'text-center'
        },
        {
          key: 'preview',
          label: 'Preview',
          class: 'text-center'
        }
      ],
      openKmAuth: null,
      uploadedFileName: null,
      docDtlId: null,
      authToken: null
    };
  },
  methods: {
    // 1.0 <Gourav> to get tds data
    getTdsFormData() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        assessment_year: this.assessmentYear.value,
        pan_no: this.panNumber
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getTdsFormData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.tdsCertificateData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    //1.0 <Gourav> to open ValueSet
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    //1.0 <Gourav> to select the value from valueset
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.ASSESSMENT_YEAR) {
        this.assessmentYear = {
          text: item.value_meaning,
          value: item.value_code
        };
      }
    },
    //1.0 <Gourav> to clear the value 
    clearVsetValues(vsetCode) {
      if (vsetCode === 'ASSESSMENT_YEAR') {
        this.assessmentYear = {
          text: null,
          value: null
        };
      }
    },
     //1.0 <Gourav> to clear the value of all filter
    clearFilters() {
      this.assessmentYear = {
        text: null,
        value: null
      };
      this.panNumber = null;
    },
     //1.0 <Gourav> api for authenticate to get authToken
    getOpenKmAuthenticate(uuid, fileName) {
      const payload = {
        password: null,
        saved_password_flag: true,
        user_name: null
      };
      this.loader = true;
      this.$store
      // .dispatch('intWorkflow/openKmAuthenticate', payload) 
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate', payload) //Gourav 1.1 change in api
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (this.openKmAuth) {
              this.downloadDocument(uuid, fileName);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    //1.0 <Gourav> to download the pdf file of tds
    downloadDocument(uuid, fileName) {
      const url =
        this.downloadDocUrl +
        '/download/tds/' +
        uuid +
        '?token=' +
        this.openKmAuth;
      commonHelper.downloadFile(url, fileName);
    },
    //1.0 <Gourav> api for authenticate to get authToken
    tempFunc(flag, docDtlId, fileName) {
      const payload = {
        password: null,
        saved_password_flag: true,
        user_name: null
      };
      this.loader = true;
      this.$store
      // .dispatch('intWorkflow/openKmAuthenticate', payload) 
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate', payload) ////Gourav 1.1 change in api
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            this.showHideOpenModal(flag, docDtlId, fileName);
          }
        });
    },
    //1.0 <Gourav> to preview the tds pdf
    showHideOpenModal(flag, docDtlId, fileName) {
      if (flag) {
        this.fileExtension = commonHelper.getFileExtension(fileName);
      }
      if (this.fileExtension === 'xlsx') {
        alert('Not Allowed');
      } else {
        this.showOpenModal = flag;
        this.docDtlId = docDtlId;
        this.authToken = this.openKmAuth;
        this.uploadedFileName = fileName;
      }
    }
  }
};
